/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Swap_Level_NInputs */

const en_us2_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Level ${i?.n}`)
};

const pt_br2_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nível ${i?.n}`)
};

const es_419_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nivel ${i?.n}`)
};

const pt_pt2_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nível ${i?.n}`)
};

const fr_fr2_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Niveau ${i?.n}`)
};

const de_de2_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stufe ${i?.n}`)
};

const it_it2_swap_level_n = /** @type {(inputs: Swap_Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Livello ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Level {n}" |
*
* @param {Swap_Level_NInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_level_n = /** @type {((inputs: Swap_Level_NInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Level_NInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_level_n(inputs)
	if (locale === "es-419") return es_419_swap_level_n(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_level_n(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_level_n(inputs)
	if (locale === "de-DE") return de_de2_swap_level_n(inputs)
	if (locale === "it-IT") return it_it2_swap_level_n(inputs)
	return en_us2_swap_level_n(inputs)
});
export { swap_level_n as "swap.level_n" }